import { MapPin, Award, Clock, Users, Shield, Zap } from 'lucide-react';

export const mockData = {
  features: [
    {
      icon: <Award className="w-8 h-8" />,
      title: "Premium Courts",
      description: "State-of-the-art padel courts with professional-grade surfaces and optimal lighting"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Expert Coaching",
      description: "Learn from certified coaches with years of professional padel experience"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Flexible Booking",
      description: "Book courts 24/7 through our easy-to-use platform with instant confirmation"
    }
  ],

  locations: [
    {
      name: "Ozone Avenue",
      address: "Kochi, Kerala",
      addressLine2: "Jawahar Nagar Ave, near District7 Encore",
      description: "Our flagship location featuring 2 outdoor courts with premium surfaces, lounge area, and pro shop.",
      image: "https://customer-assets.emergentagent.com/job_ace-padel/artifacts/1ptpwggh_WhatsApp%20Image%202025-11-03%20at%2016.49.48_5b9a56e1.jpg",
      courts: 2,
      type: "Outdoor"
    },
    {
      name: "Space# Padel & Pickle - Kakkanad",
      address: "Palal Gardens, Chittethukara, Kakkanad",
      description: "Our newest facility in Kakkanad featuring premium padel and pickleball courts with state-of-the-art amenities.",
      image: "https://customer-assets-rejwkqb3.emergentagent.net/job_6382caaa-f387-4f0f-a2f6-6f15c2e16957/artifacts/lbj3mjjb_image.png",
      courts: 4,
      type: "Indoor"
    },
    {
      name: "Trivandrum",
      address: "Trivandrum, Kerala",
      description: "Coming in Q1 2027! Modern facility with premium courts, café, and dedicated training area for all skill levels.",
      image: "https://customer-assets.emergentagent.com/job_ace-padel/artifacts/yxy6tqh1_trivandrum%20image.jpg",
      courts: 4,
      type: "Coming Soon",
      comingSoon: true
    },
    {
      name: "Kozhikode",
      address: "Kozhikode, Kerala",
      description: "Coming in Q1 2027! Premium padel courts bringing the fastest-growing racket sport to Kozhikode.",
      image: "https://static.prod-images.emergentagent.com/jobs/6382caaa-f387-4f0f-a2f6-6f15c2e16957/images/84d596eff87b092940e248b62c752e87d76b58955742c2ec3a80c4bed8ee7b87.jpeg",
      courts: 4,
      type: "Coming Soon",
      comingSoon: true
    },
    {
      name: "Bangalore",
      address: "Bangalore, Karnataka",
      description: "Coming in Q2 2027! Our largest facility yet with 6 premium courts, lounge, and pro shop.",
      image: "https://static.prod-images.emergentagent.com/jobs/6382caaa-f387-4f0f-a2f6-6f15c2e16957/images/0441cb26c4b77ec68cfc0ef3a80c0bd5ae942d40678308107c620a969990c894.jpeg",
      courts: 6,
      type: "Coming Soon",
      comingSoon: true
    }
  ],

  coachingOptions: [
    {
      title: "Private Lessons",
      description: "One-on-one coaching tailored to your specific needs and skill level",
      features: [
        "Personalized training plan",
        "Video analysis included",
        "Flexible scheduling",
        "Equipment provided"
      ]
    },
    {
      title: "Group Clinics",
      description: "Learn with others in a fun, social environment with expert guidance",
      features: [
        "Max 8 players per group",
        "Skill-level matched",
        "Weekly sessions available",
        "Equipment provided"
      ]
    },
    {
      title: "Corporate Programs",
      description: "Team building and corporate wellness programs for your organization",
      features: [
        "Customized packages",
        "Private court access",
        "Catering available",
        "Group discounts"
      ]
    }
  ],

  benefits: [
    {
      icon: <MapPin className="w-12 h-12" />,
      title: "Convenient Locations",
      description: "Multiple locations across the city make it easy to find a court near you, whether at home or work."
    },
    {
      icon: <Users className="w-12 h-12" />,
      title: "Social & Fun",
      description: "Doubles format makes it perfect for socializing. Meet new people and build lasting friendships through the sport."
    },
    {
      icon: <Award className="w-12 h-12" />,
      title: "Great Workout",
      description: "Burn calories while having fun. Padel provides excellent cardio and improves reflexes, coordination, and agility."
    }
  ],

  franchise: {
    title: "Join the Padel Revolution",
    subtitle: "Partner with space# and bring premium padel to your community",
    description: "We're expanding across India and looking for passionate partners to join our growing network. With space#, you're not just opening a padel facility – you're becoming part of a thriving community and a sport that's taking the world by storm.",
    benefits: [
      "Comprehensive training and operational support",
      "Proven business model with strong ROI",
      "Marketing and branding support",
      "Access to our booking technology platform",
      "Ongoing coaching and staff training programs",
      "Community building expertise"
    ]
  },

  timeSlots: [
    "06:00 AM", "07:00 AM", "08:00 AM", "09:00 AM", "10:00 AM", "11:00 AM",
    "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
    "06:00 PM", "07:00 PM", "08:00 PM", "09:00 PM", "10:00 PM", "11:00 PM"
  ],

  faqs: [
    {
      question: "What is padel?",
      answer: "Padel is a racquet sport that combines elements of tennis and squash. It's played in doubles on an enclosed court about one-third the size of a tennis court. The ball can be played off the walls, making it dynamic and exciting. It's easy to learn but challenging to master, making it perfect for players of all skill levels."
    },
    {
      question: "Do I need to bring my own equipment?",
      answer: "We provide balls for free, and rackets are available for a small rental fee. However, if you have your own equipment, you're welcome to bring it. We also have a pro shop where you can purchase or upgrade your gear."
    },
    {
      question: "How do I book a court?",
      answer: "Booking is easy! Simply select your preferred location above, choose your date and time, and complete your reservation online or you can book your slots on the https://www.pi-play.com apps. You'll receive instant confirmation via email. For group bookings or special events, please contact us directly."
    },
    {
      question: "What should I wear?",
      answer: "Wear comfortable athletic clothing and court shoes with non-marking soles. We recommend tennis or running shoes. Avoid black-soled shoes as they may mark the court surface."
    },
    {
      question: "Do you offer coaching for beginners?",
      answer: "Absolutely! We offer private lessons, group clinics, and beginner programs. Our certified coaches will help you learn the basics and develop your skills at your own pace. Check out our coaching section above for more details."
    },
    {
      question: "Can I host a private event or tournament?",
      answer: "Yes! We can accommodate private events, corporate outings, birthday parties, and tournaments. Contact us to discuss your specific needs and we'll create a customized package for you."
    },
    {
      question: "What are your cancellation policies?",
      answer: "Court bookings can be cancelled up to 24 hours before your scheduled time for a full refund. Cancellations made within 24 hours are subject to a 50% fee. Coaching sessions require 48 hours notice for cancellation."
    }
  ]
};